"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterBoolean(array) {
    return array.filter(Boolean);
}
exports.default = filterBoolean;
